import { getConfig } from './config';

// eslint-disable-next-line no-console
const logger = (level) => (...message) => getConfig().debugEnabled && console[level](...message);

export const debug = {
  debug: logger('debug'),
  info: logger('info'),
  log: logger('log'),
  warn: logger('warn'),
  error: logger('error'),
  trace: logger('trace'),
};
